<template>
  <div>
    <gg-card class="mb-4">
      <gg-card-header>
        Affiliate Banner Instructions
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <p class="pt-2">
              Below are the available banners that you as an affiliate are free to use grouped by our most popular
              products & services.
            </p>
            <b>Banner Sizes</b>
            <p>
              The banner previews are slightly resized for ease of view purposes. You will be able to view the full size
              banner by clicking on "View Full Size".
            </p>
            <b>Affiliate Code</b>
            <p>
              To link to us with your affiliate code, simply copy and paste the entire HTML code on to your website.
              Your affiliate ID is already embedded into the code.
            </p>
            <b>Campaign Codes</b>
            <p class="mb-0">
              For those affiliates who have created campaign codes for detailed tracking, you can select the campaign code
              you wish to generate the HTML code for. You will then be able to simply copy/paste the code to your website.
            </p>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>

    <gg-card>
      <gg-card-header>
        Banners
      </gg-card-header>
      <gg-card-text class="text-center">
        <div class="d-inline-flex">
          <div class="text-left">
            <gg-select outlined :items="tabTitles" v-model="tab" item-value="id" label="Select Banner Type" />
          </div>

        </div>

        <v-tabs v-model="tab">
          <v-tab-item v-for="(items, i) in tabItems" :key="`item-${i}`">
            <v-card flat class="px-4 pt-4">
              <v-card-text v-if="profile">
                  <banner v-for="(banner, j) in items" :key="`banner-${j}`"
                          :affiliate="profile.username"
                          :campaigns="campaignCodes"
                          :image-url="banner.image"
                          :size="banner.size" />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Banner from './Banner'

export default {
  name: 'Banners',
  components: { Banner },
  data () {
    return {
      loading: false,
      tab: 0,
      tabTitles: [
        { text: 'WordPress Hosting', id: 0, },
        { text: 'VPS Hosting', id: 1, },
        { text: 'Shared Hosting', id: 2, },
        { text: 'Reseller Hosting', id: 3, },
        { text: 'Green Tags', id: 4, },
        { text: 'Drupal Hosting', id: 5, },
      ],
      tabItems: [
        // wp items:
        [
          { image: 'https://ads.greengeeks.com/wp/wp_001_200x200.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/wp/wp_001_250x250.png', size: '250x250' },
          { image: 'https://ads.greengeeks.com/wp/wp_001_300x250.png', size: '300x250' },
          { image: 'https://ads.greengeeks.com/wp/wp_001_320x100.png', size: '320x100' },
          { image: 'https://ads.greengeeks.com/wp/wp_001_468x60.png', size: '468x60' },
          { image: 'https://ads.greengeeks.com/wp/wp_001_728x90.png', size: '728x90' },
          { image: 'https://ads.greengeeks.com/wp/wp_001_970x90.png', size: '970x90' },
          { image: 'https://ads.greengeeks.com/wp/wp_001_336x280.png', size: '336x280' },
          { image: 'https://ads.greengeeks.com/wp/wp_001_160x600.png', size: '160x600' },
          { image: 'https://ads.greengeeks.com/wp/wp_001_300x600.png', size: '300x600' },
        ],
        // vps items:
        [
          { image: 'https://ads.greengeeks.com/00030036.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00030037.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00030038.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00030039.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00030040.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00030041.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00030042.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00030043.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00030044.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00030034.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00030035.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00030039.gif', size: '200x200' },
        ],
        // shared items:
        [
          { image: 'https://ads.greengeeks.com/0001009.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00010015.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00010021.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00010027.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00010030.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00010033.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00010024.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/0001003.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/0001006.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00010018.gif', size: '200x200' },
        ],
        // reseller items:
        [
          { image: 'https://ads.greengeeks.com/0002008.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00020011.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00020014.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00020020.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00020026.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00020029.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00020032.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00020023.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/0002002.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/0002005.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00020017.gif', size: '200x200' },
        ],
        // green items:
        [
          { image: 'https://ads.greengeeks.com/Green_9.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_12.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_11.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_7.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_14.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_15.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_8.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_10.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_13.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_3.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_5.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_18.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_20.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_6.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_23.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_24.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_26.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_19.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_4.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_1.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_16.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_17.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_2.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_21.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_22.png', size: '200x200' },
          { image: 'https://ads.greengeeks.com/Green_25.png', size: '200x200' },
        ],
        // drupal items:
        [
          { image: 'https://ads.greengeeks.com/0005007.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00050010.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00050013.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00050019.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00050025.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00050028.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00050031.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00050022.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/0005001.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/0005004.gif', size: '200x200' },
          { image: 'https://ads.greengeeks.com/00050016.gif', size: '200x200' },
        ],
      ],
    }
  },
  computed: {
    ...mapGetters({
      campaigns: 'affiliates/campaigns',
      profile: 'affiliates/profile'
    }),
    campaignCodes () {
      return this.campaigns.map(c => c.code)
    }
  },
  methods: {
    ...mapActions({
      affCampaigns: 'affiliates/affCampaigns',
      getProfile: 'affiliates/getProfile',
      reportError: 'reportError'
    }),
    async getData () {
      this.loading = true
      try {
        await this.getProfile()
        await this.affCampaigns({ action: 'campaign_codes' })
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
  },
  mounted () {
    this.getData()
  }
}
</script>
